import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Badge, Button, Col, Container, Form, Modal, Row } from 'react-bootstrap';
import DynamicBreadcrumb from '../header/breadcrumb';
import offerAPI from "../../services/offerapi";
import moment from "moment";
import { Box } from "@mui/material";
import { DataGrid, GridToolbar, gridClasses } from "@mui/x-data-grid";
import $ from "jquery";
import "bootstrap-datepicker";
import { useParams } from "react-router-dom";
import OfferButtons from "./offerButton";
import { showConfirm } from "react-confirm-prompt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
library.add(fas);

const DiscountDetail = () => {
    const { id } = useParams();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalOffer, setTotalOffer] = useState(0);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 15,
    });
    const [sortModel, setSortModel] = useState([
        { field: 'id', sort: 'desc' },
    ]);
    const [filterModel, setFilterModel] = useState({ items: [] });
    const [createdDateFilter, setCreatedDateFilter] = useState({ start: null, end: null });
    const [rowSelectionModel, setRowSelectionModel] = useState([]);
    const [offerProductId, setOfferProductId] = useState(null);
    const [offerProductStatus, setOfferProductStatus] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [notesText, setNotesText] = useState("Enter Reason");
    const [errors, setErrors] = useState({});
    const [closeNotes, setCloseNotes] = useState("");

    const pathArray = useMemo(() => [{ name: "Discount Offers List", url: null }], []);
    const statusArr = useMemo(() => ({
        1: "Active",
        2: "Inactive"
    }), []);
    const statusColors = useMemo(() => ({
        Pending: "secondary",
        Active: "success",
        Inactive: "danger",
    }), []);

    const fetchOffers = useCallback(async () => {
        setLoading(true);
        try {
            setRowSelectionModel([]);
            const { page, pageSize } = paginationModel;
            const data = await offerAPI.getOfferDetails({
                offerId: id,
                limit: pageSize,
                page,
                sortModel,
                filterModel: {
                    ...filterModel,
                    createdDate: createdDateFilter,
                },
            });
            const formattedRows = data.data.result.map((cust, index) => {
                return {
                    id: cust.id,
                    sno: index + 1,
                    created_at: moment(cust.created_at).format("YYYY/MM/DD kk:mm:ss"),
                    offer_start_date: moment(cust.start_date).format("YYYY/MM/DD kk:mm:ss"),
                    offer_end_date: moment(cust.end_date).format("YYYY/MM/DD kk:mm:ss"),
                    offer_name: cust.offer_name,
                    status: cust.status,
                    pro_name: cust.pro_name,
                    // Concatenating item_spec + item_unit as a single column
                    itemSpecUnit: `${cust.item_spec || ''} ${cust.item_unit || ''}`,
                    // Adding item_ref_code column
                    itemRefCode: cust.item_ref_code || 'N/A',
                    value_type: cust.value_type,
                    discount_value: cust.discount_value,

                };
            });

            setRows(formattedRows);
            setTotalOffer(data.data.totalRecords[0].totalRecords || 0);
        } catch (error) {
            console.error("Failed to fetch Offers:", error);
        } finally {
            setLoading(false);
        }
    }, [paginationModel, sortModel, filterModel, createdDateFilter]);

    useEffect(() => {
        fetchOffers();
    }, [fetchOffers]);

    const columns = useMemo(() => [
        { field: "sno", headerName: "S NO", sortable: false },
        { field: "created_at", headerName: "Created ON", flex: 1 },
        {
            field: "itemSpecUnit",
            headerName: "Unit",
            width: 300,
            renderCell: (params) => (
                <>
                    <span>{params.row.pro_name}</span><br />
                    <span>{params.row.itemSpecUnit}</span>
                </>
            ),
        },
        {
            field: "itemRefCode",
            headerName: "Ref Code",
            flex: 1,
        },
        {
            field: "discount",
            headerName: "Discount",
            flex: 1,
            renderCell: (params) => {
                const { value_type, discount_value } = params.row;
                return value_type === 0
                    ? `${discount_value}%`      // Percentage
                    : `₹${discount_value}`;     // Fixed price with currency in front
            },
        },
        { field: "offer_start_date", headerName: "Start ON", flex: 1 },
        { field: "offer_end_date", headerName: "End ON", flex: 1 },
        {
            field: "status",
            headerName: "Status",
            width: 150,
            renderCell: (params) => (
                <Row>
                    <Col
                        key={params.id + "-status"}
                        className={"ms-2 p-2 me-2 d-grid gap-2"}
                    >
                        <button
                            onClick={() => handleStatusClick(params.id, parseInt(params.value))}
                            className={`btn ${params.value === 1 ? "btn-danger" : "btn-secondary"} custom-status-button`}
                            style={{ outline: "none", boxShadow: "none" }}
                        >
                            {params.value === 1 ? "Active" : "Inactive"}
                        </button>
                    </Col>
                </Row>
            ),
        },
    ], []);

    const handleDateChange = (value, type) => {
        if (type === "start") {
            setCreatedDateFilter((prev) => ({ ...prev, start: value }));
        } else if (type === "end") {
            setCreatedDateFilter((prev) => ({ ...prev, end: value }));
        }
    };

    const applyFilters = () => {
        setFilterModel({
            items: [
                { columnField: 'createdAt', operatorValue: 'isAfter', value: createdDateFilter.start },
                { columnField: 'createdAt', operatorValue: 'isBefore', value: createdDateFilter.end },
            ],
        });
    };

    const resetFilters = () => {
        setCreatedDateFilter({ start: null, end: null });
        setFilterModel({ items: [] });
        $("#startDate").datepicker("clearDates");
        $("#endDate").datepicker("clearDates");
    };

    useEffect(() => {
        $("#startDate").datepicker({
            format: "yyyy-mm-dd",
            clearBtn: true,
            autoclose: true,
            todayHighlight: true,
            endDate: "today",
        }).on("changeDate", (e) => {
            setCreatedDateFilter((prevState) => ({
                ...prevState,
                start: e.format("yyyy-mm-dd"),
            }));
            $("#endDate").datepicker("setStartDate", e.date);
        });

        $("#endDate").datepicker({
            format: "yyyy-mm-dd",
            clearBtn: true,
            autoclose: true,
            todayHighlight: true,
            startDate: "+0d",
            endDate: "today",
        }).on("changeDate", (e) => {
            setCreatedDateFilter((prevState) => ({
                ...prevState,
                end: e.format("yyyy-mm-dd"),
            }));
        });

        return () => {
            $("#startDate").datepicker("destroy");
            $("#endDate").datepicker("destroy");
        };
    }, []);

    const removeClick = () => {
        if (rowSelectionModel.length > 0) {
            showConfirm("Are you sure?", {
                description: "You want to remove selected product items ",
                type: "info",
            }).then((answer) => {
                if (answer) {
                    removeOfferHandle('selected');
                }
            });
        } else {
            alert("Kindly select items first");
        }
    };
    const removeAllClick = () => {
        showConfirm("Are you sure?", {
            description: "You want to remove all the items ",
            type: "info",
        }).then((answer) => {
            if (answer) {
                removeOfferHandle('all');
            }
        });
    };

    const validateCancelForm = () => {
        const newErrors = {};
        if (!closeNotes) newErrors.closeNotes = "Notes is required";
        return newErrors;
    };
    const handleStatusClick = (Id, status) => {
        const sureTxt =
            status === 1
                ? "Are you sure to change status to inactive?"
                : "Are you sure to change status to active?";
        const decTxt =
            status === 1
                ? "This will inactivate the item"
                : "This will activate the item";
        showConfirm(sureTxt, {
            description: decTxt,
            type: "info",
        }).then((answer) => {
            if (answer) {
                setOfferProductId(Id);
                setOfferProductStatus(status);
                if (status !== 1) {
                    submitUpdateDetails(Id, status);
                } else {
                    setOpenModal(true);
                }
            }
        });
    };
    const handleInactivate = async (event) => {
        event.preventDefault();
        const formErrors = validateCancelForm();
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
        } else {
            setErrors({});
            try {
                submitUpdateDetails(offerProductId, offerProductStatus, closeNotes);
            } catch (error) {
                setErrors({ common: "Update Failed" });
            }
        }
    };

    const removeOfferHandle = async (action = 'selected') => {

        let selectedIds = action === 'selected' ? rowSelectionModel : null;
        let params = {
            status: 3,
            offerProductIds: selectedIds,
            action,
            offerId: id
        };

        const resp = await offerAPI.updateOfferProductStatus(params);
        if (resp) {
            const message = resp.message || "Offer Product status updated successfully";
            showConfirm("Success", {
                description: message,
                type: "Success",
                hideCancel: true,
            }).then(() => {
                setOpenModal(false);
            });
        } else {
            const message = "Process failed, kindly try again later!";
            showConfirm("Oops!", {
                description: message,
                type: "warning",
                hideCancel: true,
            }).then(() => {
                setOpenModal(false);
            });
        }
        fetchOffers();
    }

    const submitUpdateDetails = async (offerProductId, status, notes = null) => {
        try {
            let sendStatus = status === 1 ? 2 : 1;
            let params = {
                action: "status",
                status: sendStatus,
                offerProductId: offerProductId,
                reason: notes,
            };
            const resp = await offerAPI.updateOfferProductStatus(params);
            if (resp) {
                const message = resp.message || "Offer Product status updated successfully";
                showConfirm("Success", {
                    description: message,
                    type: "Success",
                    hideCancel: true,
                }).then(() => {
                    setOpenModal(false);
                });
            } else {
                const message = "Process failed, kindly try again later!";
                showConfirm("Oops!", {
                    description: message,
                    type: "warning",
                    hideCancel: true,
                }).then(() => {
                    setOpenModal(false);
                });
            }
            fetchOffers();
            handleClose();
        } catch (error) {
            showConfirm("Oops!", {
                description: "Process failed, kindly try again later!",
                type: "warning",
                hideCancel: true,
            });
            handleClose();
        }
    };

    const setReason = (e) => {
        setCloseNotes(e.target.value);
    };

    const handleClose = () => {
        setOpenModal(false);
        setNotesText("Enter Reason");
    };

    return (
        <Container>
            <DynamicBreadcrumb breadcrumb={pathArray} />

            <Row className="mb-4">
                <Col sm={3}>
                    <input
                        id="startDate"
                        type="text"
                        className="form-control"
                        placeholder="Start Date"
                        onChange={(e) => handleDateChange(e.target.value, "start")}
                    />
                </Col>
                <Col sm={3}>
                    <input
                        id="endDate"
                        type="text"
                        className="form-control"
                        placeholder="End Date"
                        onChange={(e) => handleDateChange(e.target.value, "end")}
                    />
                </Col>
                <Col sm={4} className="d-flex justify-content-between">
                    <Button className="ms-1" variant="primary" onClick={applyFilters}>
                        Apply Filters
                    </Button>
                    <Button className="ms-1" variant="secondary" onClick={resetFilters}>
                        Reset Filters
                    </Button>
                </Col>
            </Row>
            <Row className="mt-2">
                <OfferButtons removeClick={removeClick} removeAllClick={removeAllClick} />
            </Row>
            <Row className="mt-2">
                <Box>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        getRowHeight={() => "auto"}
                        rowsPerPageOptions={[5, 10, 20]}
                        paginationMode="server"
                        rowCount={totalOffer}
                        loading={loading}
                        checkboxSelection
                        disableRowSelectionOnClick
                        paginationModel={paginationModel}
                        onPaginationModelChange={setPaginationModel}
                        sortingMode="server"
                        filterMode="server"
                        sortModel={sortModel}
                        onSortModelChange={setSortModel}
                        onFilterModelChange={setFilterModel}
                        components={{
                            Toolbar: GridToolbar,
                        }}
                        onRowSelectionModelChange={(row) => {
                            setRowSelectionModel(row);
                        }}
                        rowSelectionModel={rowSelectionModel}
                        autosizeOptions={{
                            columns: ["itemSpecUnit", "status"],
                            includeOutliers: true,
                            includeHeaders: false,
                        }}
                        slots={{
                            toolbar: GridToolbar,
                        }}
                        slotProps={{
                            toolbar: {
                                showQuickFilter: true,
                                printOptions: { disableToolbarButton: true },
                                csvOptions: { disableToolbarButton: true },
                            },
                        }}
                        sx={{
                            [`& .${gridClasses.cell}`]: {
                                py: 0.5,
                            },
                        }}
                    />
                </Box>
            </Row>

            <Modal show={openModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title> Enter Reason</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form className="cancelForm">
                        <Form.Group className="mb-3" controlId="closeNotes">
                            <Form.Label>Enter inactivate reason</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={closeNotes}
                                onChange={setReason}
                                isInvalid={!!errors.closeNotes}
                            />
                        </Form.Group>
                        <Form.Control.Feedback type="invalid">
                            {errors.closeNotes}
                        </Form.Control.Feedback>
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={handleInactivate}>
                        Submit Reason
                    </Button>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default DiscountDetail;
